import { MouseEvent } from 'react';
import { matchPath, useHistory } from 'react-router-dom';

import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { SearchBreadcrumbPageNames } from './GridFilteredBySearch.breadcrumb';

interface IBillingBCFilteredByBreadcrumb {
  defaultText: string;
  breadcrumbPage: SearchBreadcrumbPageNames;
  path: string;
}

export default function BillingBCFilteredByBreadcrumb({
  defaultText,
  breadcrumbPage,
  path
}: IBillingBCFilteredByBreadcrumb) {
  const history = useHistory();
  const urlParams = new URL(window.location.href).searchParams;
  const searchText = urlParams.get('search') ?? '';
  const billingCycleId = urlParams.get('billingCycleId') ?? '';
  const salesOrderId = urlParams.get('salesOrderId') ?? '';

  const onClick = (event: MouseEvent) => {
    event.preventDefault();
    const pathName = new URL(window.location.href).pathname;

    const isOnCurrentPage = matchPath(pathName, {
      path: path,
      exact: true
    });

    if (isOnCurrentPage) {
      window.location.reload();
    } else {
      let link = path;
      if (billingCycleId) {
        link = `${path}?billingCycleId=${billingCycleId}`;
      } else if (salesOrderId) {
        link = `${path}?salesOrderId=${salesOrderId}`;
      } else if (searchText) {
        link = `${path}?search=${encodeURIComponent(searchText)}`;
      }
      history.push(getParameterizedLink(link));
    }
  };

  if (billingCycleId) {
    return (
      <a onClick={onClick} href={window.location.href}>
        {`${breadcrumbPage} filtered by Billing Cycle: ${billingCycleId}`}
      </a>
    );
  }

  if (salesOrderId) {
    return (
      <a onClick={onClick} href={window.location.href}>
        {`${breadcrumbPage} filtered by Sales Order: ${salesOrderId}`}
      </a>
    );
  }

  if (searchText) {
    return (
      <a onClick={onClick} href={window.location.href}>
        {`${breadcrumbPage} searched by: ${searchText}`}
      </a>
    );
  }

  return (
    <a onClick={onClick} href={window.location.href}>
      {defaultText}
    </a>
  );
}
